import { Link } from "react-router-dom";
import { PageHero } from "@/components/sections/PageHero";
import { CTABand } from "@/components/sections/CTABand";
import { SERVICES, IMAGES } from "@/lib/site";
import { ArrowRight } from "lucide-react";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow="Services"
        title={<>Coatings, prep, and stripping <span className="text-[#FF5722]">under one roof.</span></>}
        subtitle="Every service listed below runs through the same production floor, the same QC process, and the same single point of accountability."
        image={IMAGES.powder1}
      />

      <section className="section px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map(s => (
            <Link
              key={s.slug}
              to={`/services/${s.slug}`}
              className="group border border-white/10 hover:border-[#FF5722] transition-colors overflow-hidden bg-[#0B0B0D]"
              data-testid={`services-card-${s.slug}`}
            >
              <div className="relative h-64 overflow-hidden">
                <img src={s.image} alt={s.title} className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />
              </div>
              <div className="p-8">
                <div className="eyebrow mb-3">{s.tag}</div>
                <div className="font-display text-3xl tracking-tight">{s.title}</div>
                <p className="mt-4 text-zinc-400 leading-relaxed">{s.short}</p>
                <div className="mt-6 flex items-center gap-2 text-[#FF5722] text-sm uppercase tracking-widest">
                  Explore <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
